module.exports = __webpack_public_path__ + "img/share-2 (2).c6c82663.svg";